<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input"
                @submit.prevent="storeFuelLog">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Create Fuel Refill Entry</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-select v-model="formData['vehicle_fuel_type_id']"
                                      :items="fuelTypes"
                                      :rules="[vRules.required]"
                                      autofocus density="compact" item-title="name"
                                      item-value="id" label="Select Fuel Type"/>

                            <v-select v-model="formData['driver_payment_type_id']"
                                      :items="paymentTypes"
                                      :rules="[vRules.required]"
                                      density="compact" item-title="name"
                                      item-value="id" label="Select Payment Type"/>

                            <v-text-field v-model="formData['vendor']" :rules="[vRules.required]"
                                          density="compact" label="Vendor/ Location" maxlength="150"/>

                            <v-text-field v-model="formData['odometer']" :rules="[vRules.required]"
                                          density="compact" :label="`Odometer (${distanceUnitLabel})`" maxlength="8"/>

                            <v-text-field v-model="formData['quantity']" :rules="[vRules.required]"
                                          density="compact" label="Quantity" type="number"/>

                            <v-text-field v-model="formData['cost_per_unit']" :rules="[vRules.required]"
                                          density="compact" label="Cost per unit" type="number"/>

                            <v-text-field v-model="formData['tax']" :rules="[vRules.required]"
                                          density="compact" label="Tax" type="number"/>

                            <v-text-field :model-value="totalCost" density="compact" label="Total Cost" readonly/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, computed} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {useAuthStore} from "@/stores/authStore";

const snackbar = useSnackbarStore();
const distanceUnitLabel = computed(() => useAuthStore().configs?.distance_unit === 'km' ? 'km' : 'mi');
const props = defineProps({
    modelValue: Boolean,
    serviceType: Number,
    paymentTypes: Array,
    fuelTypes: Array,
    record: Object,
    asset: Object,
});
const formData = reactive({
    valid: false,
    asset_id: props.asset.id,
    vehicle_fuel_type_id: props.record?.vehicle_fuel_type_id ?? null,
    driver_payment_type_id: props.record?.driver_payment_type_id ?? null,
    vendor: props.record?.vendor ?? props.record.vendor ?? null,
    odometer: props.record?.odometer ?? props.asset.odometer ?? 0,
    cost_per_unit: props.record?.cost_per_unit ?? 0,
    tax: props.record?.tax ?? 0,
    quantity: props.record?.quantity ?? 1,
});

const emits = defineEmits(['update:modelValue', 'addFuelLog', 'updateFuelLog']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);
const totalCost = computed(() => {
    return ((parseFloat(formData['cost_per_unit'] ?? 0) * parseFloat(formData['quantity'] ?? 0)) + parseFloat(formData['tax'] ?? 0)).toFixed(2)
})
const storeFuelLog = () => {
    errors.value = [];
    send(`${props.record?.id ? 'put' : 'post'}`,
        `fleet/fuel-logs${props.record?.id ? '/' + props.record.id : ''}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits(props.record?.id ? 'updateFuelLog' : 'addFuelLog', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}
</script>
